// extracted by css-extract-rspack-plugin
export default {"container":"SidebarTemplateRepository-module__container__m7Z05"};